import { Fragment } from "react";
import { m } from "framer-motion";
import dynamic from "next/dynamic";

const ReactPlayer = dynamic(() => import("react-player"), {
    ssr: false,
});

const isApple =
    typeof window !== "undefined" &&
    window.navigator.appVersion.indexOf("iPhone") > -1;

export const TrophyRBEmpty = () => {
    return (
        <img
            src="/assets/images/trophy-round-bottom-empty.png"
            alt="trophy-empty"
            className="object-contain w-full h-full"
        />
    );
};

export const TrophyRBFull = ({
    fx = false,
    stars = 0,
    video = false,
    endscreen = false,
}) => {
    // console.log("Stars: " + stars + " Fx: " + fx + " Video: " + video);

    if (fx) {
        if (video) {
            return (
                <div className="player-wrapper">
                    <ReactPlayer
                        className="react-player"
                        url={
                            "/assets/videos/" + Math.round(stars) + "-star.webm"
                        }
                        loop={false}
                        muted={true}
                        playsinline={true}
                        playing={true}
                        playbackRate={2 / Math.round(stars)}
                    />
                </div>
            );
        } else {
            return (
                <Fragment>
                    <m.img
                        initial={{
                            scale: 0,
                            opacity: 0,
                        }}
                        animate={{
                            scale: 1,
                            opacity: 1,
                        }}
                        transition={{
                            duration: 0.2,
                            stiffness: 250,
                            type: "spring",
                        }}
                        src="/assets/images/trophy-round-bottom-full.png"
                        alt="trophy-full"
                        className="absolute top-0 left-0 object-contain w-full h-full"
                    />
                    <img
                        src="/assets/images/trophy-round-bottom-empty.png"
                        alt="trophy-empty"
                        className="object-contain w-full h-full"
                    />
                </Fragment>
            );
        }
    } else {
        if (video) {
            return (
                <div className="player-wrapper">
                    <ReactPlayer
                        className="react-player"
                        url={
                            "/assets/videos/" + Math.round(stars) + "-star.webm"
                        }
                        loop={false}
                        controls={false}
                        muted={true}
                        playsinline={true}
                        playing={true}
                        playbackRate={
                            Math.round(stars) == 5
                                ? 2 / Math.round(stars)
                                : 2 / (Math.round(stars) + 1)
                        }
                    />
                </div>
            );
        } else {
            return (
                <img
                    src="/assets/images/trophy-round-bottom-full.png"
                    alt="trophy-full"
                    className="object-contain w-full h-full"
                />
            );
        }
    }
};

export const TrophyFBEmpty = () => {
    return (
        <img
            src="/assets/images/trophy-flat-bottom-empty.png"
            alt="trophy-empty"
            className="object-contain w-full h-full"
        />
    );
};

export const TrophyFBFull = ({ fx = false }) => {
    if (fx) {
        return (
            <Fragment>
                <m.img
                    initial={{
                        scale: 0,
                        opacity: 0,
                    }}
                    animate={{
                        scale: 1,
                        opacity: 1,
                    }}
                    transition={{
                        duration: 0.2,
                        stiffness: 150,
                        type: "spring",
                    }}
                    src="/assets/images/trophy-flat-bottom-full.png"
                    alt="trophy-full"
                    className="absolute top-0 left-0 object-contain w-full h-full"
                />
                <img
                    src="/assets/images/trophy-flat-bottom-empty.png"
                    alt="trophy-empty"
                    className="object-contain w-full h-full"
                />
            </Fragment>
        );
    } else {
        return (
            <img
                src="/assets/images/trophy-flat-bottom-full.png"
                alt="trophy-full"
                className="object-contain w-full h-full"
            />
        );
    }
};

interface CollectionStarsProps {
    stars?: number;
    bottom?: "round" | "flat";
    fx?: boolean;
    video?: boolean;
    endscreen?: boolean;
    showMarkIcon?: boolean;
}

export const CollectionTrophy: React.FC<CollectionStarsProps> = ({
    stars = 0,
    bottom = "round",
    fx = false,
    video = false,
    endscreen = false,
    showMarkIcon = false,
}) => {
    if (showMarkIcon) {
        return (
            <img
                src="/assets/animations/right-mark.gif"
                alt="trophy-mark"
                className="object-contain w-full h-full scale-150 transform-gpu"
            />
        );
    }
    if (video && !isApple) {
        if (stars > 0) {
            return (
                <TrophyRBFull
                    fx={fx ? fx : false}
                    stars={stars}
                    video={video}
                    endscreen={endscreen ? endscreen : false}
                />
            );
        } else {
            return <TrophyRBEmpty />;
        }
    } else {
        if (stars >= 5) {
            if (endscreen) {
                return <TrophyRBEmpty />;
            }
            return (
                <TrophyRBFull
                    fx={fx ? fx : false}
                    stars={stars}
                    video={video}
                    endscreen={endscreen ? endscreen : false}
                />
            );
        } else {
            return <TrophyRBEmpty />;
        }
    }
};
